import { computed, onMounted, reactive, ref } from 'vue'

export interface ITokenInfoRes {
  chainType: number;
  contract: string;
  decimals: number;
  originalSymbol: string;
  symbol: string;
  logo: string
}

export interface WalletAppInfo {
  statusBarHeight: number;
  toolBarHeight: number;
}

function checkWalletMessageToJson<T> (data: string | T): T {
  if (typeof data === 'string') {
    return JSON.parse(data)
  } else {
    return data
  }
}

export function checkFxWalletUA () {
  return /FxWalletBrowser/.test(navigator.userAgent)
}

export function getTokenInfo (): Promise<ITokenInfoRes> {
  return new Promise((resolve, reject) => {
    if (!window.fxwallet) return

    window.fxwallet.sendMessage(
      'select_token_info',
      null,
      (
        err: any,
        data: ITokenInfoRes | string
      ) => {
        if (err) {
          return reject(err)
        }

        const result = checkWalletMessageToJson<ITokenInfoRes>(data)

        console.log(result)

        resolve(result)
      }
    )
  })
  // const tokenInfo = reactive({
  //   chainType: 0,
  //   contract: '',
  //   decimals: 0,
  //   originalSymbol: '',
  //   symbol: '',
  //   logo: ''
  // })

  // onMounted(() => {

  // })

  // return {
  //   tokenInfo
  // }
}

export function getPhoneTopStyle () {
  const padTop = ref(12)

  const phoneStyle = computed(() => ({
    paddingTop: padTop.value + 'px'
  }))

  // onMounted(() => {
  //   if (checkFxWalletUA()) {
  //     window.fxwallet.sendMessage(
  //       'app_info',
  //       null,
  //       (
  //         err: any,
  //         data: WalletAppInfo | string
  //       ) => {
  //         if (err) {

  //         }

  //         const result = checkWalletMessageToJson<WalletAppInfo>(data)

  //         console.log('app_info', result)

  //         const ua = navigator.userAgent

  //         if (/Android/.test(ua)) {
  //           padTop.value = (result.statusBarHeight + result.toolBarHeight) / window.devicePixelRatio
  //         } else if (/iPad|iPhone/.test(ua)) {
  //           padTop.value = result.toolBarHeight
  //         }
  //       }
  //     )
  //   }
  // })

  return {
    padTop,
    phoneStyle
  }
}
